import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getTariffMessage = (state: StateScheme) => {
    return state.selectTariff.message
}
